import { Link } from 'react-router';
import { FileQuestion } from 'lucide-react';
import { Botao } from '@/components/ui/button';

export function PaginaNaoEncontrada() {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-4 p-6 text-center">
      <FileQuestion className="text-silenciado-texto size-12" aria-hidden="true" />
      <h1 className="text-2xl font-semibold">Página não encontrada</h1>
      <p className="text-silenciado-texto max-w-prose">
        O endereço acessado não existe ou você não tem permissão para vê-lo.
      </p>
      <Botao asChild>
        <Link to="/">Voltar ao início</Link>
      </Botao>
    </main>
  );
}
